import { Controller } from "@hotwired/stimulus"

/**
 * Controller générique pour dispatcher des événements custom via Turbo Streams
 * Utilisation:
 * 
 * div(data-controller="event-dispatcher"
 *     data-event-dispatcher-event-name-value="myCustomEvent"
 *     data-event-dispatcher-event-data-value='{"key": "value"}'
 *     data-event-dispatcher-cleanup-delay-value="200")
 */
export default class extends Controller {
  static values = { 
    eventName: String,
    eventData: Object,
    cleanupDelay: { type: Number, default: 200 },
    bubbles: { type: Boolean, default: true },
    debug: { type: Boolean, default: false }
  }
  
  connect() {
    
    // Dispatch immédiatement lors de la connexion
    this.dispatchEvent()
    
    // Auto-cleanup après dispatch
    setTimeout(() => {
      this.cleanup()
    }, this.cleanupDelayValue)
  }
  
  dispatchEvent() {
    if (!this.eventNameValue) {
      console.error('❌ Event dispatcher: eventName is required')
      return
    }
    
    try {
      const event = new CustomEvent(this.eventNameValue, {
        detail: this.eventDataValue || {},
        bubbles: this.bubblesValue
      })
      
      if (this.debugValue) {
      }
      
      // Dispatch on multiple targets for maximum compatibility
      window.dispatchEvent(event)
      document.dispatchEvent(event)
      
      // Also dispatch using Stimulus built-in dispatch
      this.dispatch(this.eventNameValue.replace(':', '-'), { 
        detail: this.eventDataValue || {}
      })
      
    } catch (error) {
      console.error('❌ Error dispatching event:', error)
      console.error('❌ Event name:', this.eventNameValue)
      console.error('❌ Event data:', this.eventDataValue)
    }
  }
  
  cleanup() {
    if (this.element && this.element.parentNode) {
      this.element.remove()
    }
  }
}